import WatchProfile from '@/components/watch/profile/WatchProfile'
import WatchProfileEdit from '@/components/watch/profile/WatchProfileEdit'
import ContactForm from '@/components/watch/profile/ContactForm'
import DiseaseForm from '@/components/watch/profile/DiseaseForm'
import RelationForm from '@/components/watch/profile/RelationForm'
import RelationContactForm from '@/components/watch/profile/RelationContactForm'
import SSNumberForm from  '@/components/watch/profile/SSNumberForm'
import InsuranceForm from '@/components/watch/profile/InsuranceForm'

export default [
	{
		path: 'profile',
		name: 'WatchProfile',
		component: WatchProfile,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		})
	},
	{
		path: 'profile/edit',
		name: 'WatchProfileEdit',
		component: WatchProfileEdit,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			data: route.params.data
		})
	},
	{
		path: 'profile/contacts/add',
		name: 'WatchProfileContactAdd',
		component: ContactForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			action: 'add'
		})
	},
	{
		path: 'profile/contacts/:contact_id/edit',
		name: 'WatchProfileContactEdit',
		component: ContactForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			contact_id: route.params.contact_id,
			data: route.params.data,
			action: 'edit'
		})
	},
	{
		path: 'profile/diseases/add',
		name: 'WatchProfileDiseaseAdd',
		component: DiseaseForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			action: 'add'
		})
	},
	{
		path: 'profile/diseases/:disease_id/edit',
		name: 'WatchProfileDiseaseEdit',
		component: DiseaseForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			disease_id: route.params.disease_id,
			data: route.params.data,
			action: 'edit'
		})
	},
	{
		path: 'profile/relations/add',
		name: 'WatchProfileRelationAdd',
		component: RelationForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			action: 'add'
		})
	},
	{
		path: 'profile/relations/:relation_id/edit',
		name: 'WatchProfileRelationEdit',
		component: RelationForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			relation_id: route.params.relation_id,
			data: route.params.data,
			action: 'edit'
		})
	},
	{
		path: 'profile/relations/:relation_id/contacts/add',
		name: 'WatchProfileRelationContactAdd',
		component: RelationContactForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			relation_id: route.params.relation_id,
			action: 'add'
		})
	},
	{
		path: 'profile/relations/:relation_id/contacts/:contact_id/edit',
		name: 'WatchProfileRelationContactEdit',
		component: RelationContactForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			relation_id: route.params.relation_id,
			contact_id: route.params.contact_id,
			data: route.params.data,
			action: 'edit'
		})
	},
	{
		path: 'profile/ssnumbers/add',
		name: 'WatchProfileSSNumberAdd',
		component: SSNumberForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			action: 'add'
		})
	},
	{
		path: 'profile/ssnumbers/:ssnumber_id/edit',
		name: 'WatchProfileSSNumberEdit',
		component: SSNumberForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			ssnumber_id: route.params.ssnumber_id,
			data: route.params.data,
			action: 'edit'
		})
	},
	{
		path: 'profile/insurances/add',
		name: 'WatchProfileInsuranceAdd',
		component: InsuranceForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			action: 'add'
		})
	},
	{
		path: 'profile/insurances/:insurance_id/edit',
		name: 'WatchProfileInsuranceEdit',
		component: InsuranceForm,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile,
			insurance_id: route.params.insurance_id,
			data: route.params.data,
			action: 'edit'
		})
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/profile.js